// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { FaultVariant, unionToFaultVariant, unionListToFaultVariant } from "./fault-variant";
import { NormalFault, NormalFaultT, verifyNormalFault } from "./normal-fault";
import { ValuedFault, ValuedFaultT, verifyValuedFault } from "./valued-fault";

export class ElevatorFaultMessage implements flatbuffers.IUnpackableObject<ElevatorFaultMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ElevatorFaultMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsElevatorFaultMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ElevatorFaultMessage,
  ): ElevatorFaultMessage {
    return (obj || new ElevatorFaultMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsElevatorFaultMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ElevatorFaultMessage,
  ): ElevatorFaultMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ElevatorFaultMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  faultType(): FaultVariant {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : FaultVariant.NONE;
  }

  fault<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startElevatorFaultMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addFaultType(builder: flatbuffers.Builder, faultType: FaultVariant) {
    builder.addFieldInt8(0, faultType, FaultVariant.NONE);
  }

  static addFault(builder: flatbuffers.Builder, faultOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, faultOffset, 0);
  }

  static endElevatorFaultMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // fault
    return offset;
  }

  static createElevatorFaultMessage(
    builder: flatbuffers.Builder,
    faultType: FaultVariant,
    faultOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ElevatorFaultMessage.startElevatorFaultMessage(builder);
    ElevatorFaultMessage.addFaultType(builder, faultType);
    ElevatorFaultMessage.addFault(builder, faultOffset);
    return ElevatorFaultMessage.endElevatorFaultMessage(builder);
  }

  unpack(): ElevatorFaultMessageT {
    return new ElevatorFaultMessageT(
      this.faultType(),
      (() => {
        const temp = unionToFaultVariant(this.faultType(), this.fault.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: ElevatorFaultMessageT): void {
    _o.faultType = this.faultType();
    _o.fault = (() => {
      const temp = unionToFaultVariant(this.faultType(), this.fault.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): ElevatorFaultMessageT {
    const t = new ElevatorFaultMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("fault_type")) {
      t.faultType = this.faultType();
    }
    if (fieldSet.has("fault")) {
      t.fault = (() => {
        const temp = unionToFaultVariant(this.faultType(), this.fault.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class ElevatorFaultMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public faultType: FaultVariant = FaultVariant.NONE,
    public fault: NormalFaultT | ValuedFaultT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.fault === null || this.fault === undefined) {
      throw new Error('Required field "fault" is not set');
    }
    const fault = builder.createObjectOffset(this.fault);

    return ElevatorFaultMessage.createElevatorFaultMessage(builder, this.faultType, fault);
  }

  clone(): ElevatorFaultMessageT {
    const obj = new ElevatorFaultMessageT();
    obj.faultType = this.faultType;
    obj.fault =
      this.fault !== null && typeof (this.fault as any).clone === "function"
        ? (this.fault as any).clone()
        : this.fault;
    return obj;
  }

  equals(other: ElevatorFaultMessageT): boolean {
    if (this.faultType !== other.faultType) return false;
    if (this.fault !== null && other.fault !== null) {
      if (typeof (this.fault as any).equals === "function") {
        if (!(this.fault as any).equals(other.fault)) return false;
      } else if (this.fault !== other.fault) return false;
    } else if (this.fault !== other.fault) return false;
    return true;
  }
}

export function verifyElevatorFaultMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "fault");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // NormalFault
            {
              const o = verifier.readInt32(pos);
              verifyNormalFault(verifier, pos + o);
            }
            break;
          case 2: // ValuedFault
            {
              const o = verifier.readInt32(pos);
              verifyValuedFault(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "fault");
  } finally {
    verifier.popDepth();
  }
}
